/* eslint-disable no-async-promise-executor */
import React from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import DashboardLayout from "../Layouts/DashboardLayout";
import Profile from "../Pages/Profile/Profile";
import {
  Person as PersonIcon,
  BackupTable as BackupTableIcon,
  CheckCircle as CheckCircleIcon,
  FilterList as FilterListIcon,
  RestartAlt as RestartAltIcon,
  Title as TitleIcon,
  PlaylistAddCheckCircle as PlaylistAddCheckCircleIcon,
  AdminPanelSettings as AdminPanelSettingsIcon,
  Star as StarIcon,
  StarHalf as StarHalfIcon,
  DashboardOutlined as DashboardIcon,
  InsertChartOutlined as ListIcon,
  GridOn as HeatmapIcon,
  AccessTimeOutlined as DwellIcon,
  MonitorHeartOutlined as EventsIcon,
  PersonOutlined as UsersIcon,
  ApartmentOutlined as ClientsIcon,
  LaptopOutlined as DevicesIcon,
  MonitorOutlined as IngestionIcon,
} from "@mui/icons-material";
import UserProfilePage from "../Pages/Gateway/UserProfilePage";
import DashboardPage from "../Pages/CountingModule/DashboardPage";
import ListingsPage from "../Pages/CountingModule/ListingsPage";
import ExportPage from "../Pages/CountingModule/ExportPage";
import EventsMonitorPage from "../Pages/EventsModule/EventsMonitorPage";
import DeviceStatusPage from "../Pages/EventsModule/DeviceStatusPage";
import HeatmapViewerPage from "../Pages/HeatmapModule/HeatmapViewerPage";
import DwellTimePage from "../Pages/CountingModule/DwellTimePage";
import UserManagementList from "../Pages/AdminModule/UserManagement/UserList";
import UserDetailPage from "../Pages/AdminModule/UserManagement/UserDetailPage";
import ClientsAndStoresPage from "../Pages/AdminModule/ClientsAndStoresPage";
import StoreDetailPage from "../Pages/AdminModule/StoreDetailPage";
import DevicesPage from "../Pages/AdminModule/DevicesPage";
import DeviceDetailPage from "../Pages/AdminModule/DeviceDetailPage";
import IngestionMonitorPage from "../Pages/AdminModule/IngestionMonitorPage";
import ClientDetailPage from "../Pages/AdminModule/ClientDetailPage";
import FunctionalTable from "../Pages/Table/FunctionalTable";
import FunctionalTableDetail from "../Pages/Table/FunctionalTableDetail";
import Instalation from "../Pages/GetStarted/instalation";
import CustomFiltersComponent from "../Pages/Components/CustomFilterComponent/CustomFiltersComponent";
import TableUtils from "../Pages/Components/TableComponent/TableUtils";
import TableLoad from "../Pages/Components/TableComponent/TableLoad";
import TableHeaderComponent from "../Pages/Components/TableComponent/TableHeaderComponent";
import TableActions from "../Pages/Components/TableComponent/TableActions";
import AutocompleteTreeComponent from "../Pages/Components/AutocompleteTree/AutocompleteTreeComponent";
import CustomMuiSelect from "../Pages/Components/CustomFilterComponent/CustomMuiSelect";
import { loginRequest } from "../Utils/APIutils/msalConfig";
import AuthGuard from "../Components/AuthGuard";
import useAuth from "../Context/Hooks/useCustomAuth";
import SplashScreen from "../Components/SplashScreen";
import LoginPage from "../Pages/Auth/LoginPage";
import SetPasswordPage from "../Pages/Auth/SetPasswordPage";
import AuthorizationRequired from "../Pages/Errors/AuthorizationRequired";
import ServerError from "../Pages/Errors/ServerError";
import NotFound from "../Pages/Errors/NotFound";
import AuthG from "../Pages/Components/Authguard/AuthG";
import AuthContext from "../Pages/Components/Authguard/useCustomAuth";
import Avatar from "../Pages/Components/AvatarMedal/Avatar";
import UserList from "../Pages/Examples/Users";
import UserDetails from "../Pages/Examples/Users/UserDetails";
import UserProfile from "../Pages/Examples/UserProfile";
import ModelRoles from "../Pages/Examples/UserProfile/ProfileDetail";
import FloatingTabs from "../Pages/Examples/FloatingTabs/FloatingTabs";
import FloatingTabComponent from "../Pages/Components/FloatingTab/FloatingTabComponent";
import KPIComponent from "../Pages/Components/KPI/KPIComponent";
import { Button } from '@mui/material';

const flatten = (arr) => {
  return arr.reduce((ret, item) => {
    return ret.concat(item.constructor === Array ? flatten(item) : [item]);
  }, []);
};

//Defines the path and route element
//The DashboardLayout needs to be implemented whenever a new parent is defined, otherwise the NavBar and Sidebar will not appear
export const knownRoutes = [
  {
    path: "/",
    element: (
      <Navigate
        to="/Gateway/Dashboard"
        replace
      />
    ),
  },
  {
    path: '/Examples/',
    element: <DashboardLayout />,
    children: [
      {
        title: 'sidebar:examples.functionalTable',
        path: "FunctionalTableExample",
        icon: <BackupTableIcon fontSize="small" />,
        element: <FunctionalTable />,
        handle: { crumb: "Functional Table Example", additionalContent: <Button variant="contained">Test</Button> },
        index: 1,
      },
      {
        path: "FunctionalTableExample/Form/:pid",
        element: <FunctionalTableDetail />,
        handle: { crumb: "Step Module Example" },
        parent: "FunctionalTableExample",
        index: 2,
      },
      {
        title: 'sidebar:examples.usersList',
        path: "UserList",
        icon: <PersonIcon fontSize="small" />,
        element: <UserList />,
        handle: { crumb: "User List" },
        index: 1,
      },
      {
        path: 'UserList/user/:username',
        element: <UserDetails />,
        parent: "UserList",
        handle: { crumb: "User" },
        index: 2,
      },
      {
        title: 'sidebar:examples.profilesList',
        path: "ProfilesList",
        icon: <AdminPanelSettingsIcon fontSize="small" />,
        element: <UserProfile />,
        handle: { crumb: "Profiles List" },
        index: 1,
      },
      {
        path: "ProfilesList/profile/:roleID",
        element: <ModelRoles />,
        parent: "ProfilesList",
        handle: { crumb: "Profile" },
        index: 2,
      },
      {
        title: 'sidebar:examples.formExample',
        path: "FormExample",
        icon: <PersonIcon fontSize="small" />,
        element: (
          <AuthGuard>
            <Profile />
          </AuthGuard>
        ),
        handle: { crumb: "Form Example" },
        index: 1,
      },
      {
        title: 'sidebar:examples.floatingTab',
        path: "FloatingTab",
        icon: <StarIcon fontSize="small" />,
        element: <FloatingTabs />,
        handle: { crumb: "Floating Tab Example" },
        index: 1,
      },
    ],
  },
  {
    path: "/Components/",
    element: <DashboardLayout />,
    children: [
      {
        title: 'sidebar:components.installation',
        path: "Installation",
        icon: <CheckCircleIcon fontSize="small" />,
        element: (
          <AuthGuard>
            <Instalation />
          </AuthGuard>
        ),
        handle: { crumb: "Installation" },
        index: 1,
      },
      {
        title: "AuthGuard",
        path: "AuthGard",
        icon: <BackupTableIcon fontSize="small" />,
        element: <AuthG />,
        handle: { crumb: "Authguard Component" },
        index: 1,
      },
      {
        title: "Avatar Medal",
        path: "AvatarMedal",
        icon: <PersonIcon fontSize="small" />,
        element: <Avatar />,
        handle: { crumb: "Avatar Medal Component" },
        index: 1,
      },
      {
        title: "Autocomplete Tree",
        path: "AutocompleteTree",
        icon: <PlaylistAddCheckCircleIcon fontSize="small" />,
        element: <AutocompleteTreeComponent />,
        handle: { crumb: "Autocomplete Tree Component" },
        index: 1,
      },
      {
        title: "Custom Filters",
        path: "CustomFilters",
        icon: <FilterListIcon fontSize="small" />,
        element: <CustomFiltersComponent />,
        handle: { crumb: "Custom Filters Component" },
        index: 1,
      },
      {
        title: "Custom Mui Select",
        path: "CustomMuiSelect",
        icon: <PlaylistAddCheckCircleIcon fontSize="small" />,
        element: <CustomMuiSelect />,
        handle: { crumb: "Custom Mui Select Component" },
        index: 1,
      },
      {
        title: "Table Actions",
        path: "TableActions",
        icon: <BackupTableIcon fontSize="small" />,
        element: <TableActions />,
        handle: { crumb: "Table Utils: Table Actions" },
        index: 1,
      },
      {
        title: "Table Header",
        path: "TableHeader",
        icon: <TitleIcon fontSize="small" />,
        element: <TableHeaderComponent />,
        handle: { crumb: "Table Utils: Table Header" },
        index: 1,
      },
      {
        title: "Table Loading",
        path: "TableLoading",
        icon: <RestartAltIcon fontSize="small" />,
        element: <TableLoad />,
        handle: { crumb: "Table Utils: Table Loading" },
        index: 1,
      },
      {
        title: "Table Utils",
        path: "TableUtils",
        icon: <BackupTableIcon fontSize="small" />,
        element: <TableUtils />,
        handle: { crumb: "Table Utils: Table Utils" },
        index: 1,
      },
      {
        path: "useAuthContext",
        element: <AuthContext />,
        parent: "AuthGard",
        handle: { crumb: "Context: useAuth" },
        index: 2,
      },
      {
        title: 'sidebar:examples.floatingTab',
        path: 'FloatingTab',
        icon: <StarIcon fontSize="small" />,
        element: <FloatingTabComponent />,
        handle: { crumb: "Floating Tab" },
        index: 1,
      },
      {
        title: 'sidebar:components.kpi',
        path: 'KPIComponentExample',
        icon: <StarHalfIcon fontSize="small" />,
        element: <KPIComponent />,
        handle: { crumb: "KPI Component" },
        index: 1,
      },
    ],
  },
  // ── OPERAÇÃO section label (sidebar only)
  { sectionLabel: 'sidebar:gateway.operacaoLabel' },
  {
    title: 'sidebar:gateway.dashboard',
    path: '/Gateway/Dashboard',
    icon: <DashboardIcon fontSize="small" />,
    element: (
      <DashboardLayout>
        <DashboardPage />
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.dashboard' },
  },
  {
    path: '/Gateway/Profile',
    element: (
      <DashboardLayout>
        <UserProfilePage />
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.profile' },
  },
  {
    title: 'sidebar:gateway.contagens',
    path: '/Gateway/Countings',
    icon: <ListIcon fontSize="small" />,
    requiredPermission: 'ANALYTICS_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="ANALYTICS_READ">
          <ListingsPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.countings' },
  },
  {
    title: 'sidebar:gateway.heatmap',
    path: '/Gateway/Heatmap',
    icon: <HeatmapIcon fontSize="small" />,
    requiredPermission: 'ANALYTICS_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="ANALYTICS_READ">
          <HeatmapViewerPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.heatmap' },
  },
  {
    title: 'sidebar:gateway.permanencia',
    path: '/Gateway/DwellTime',
    icon: <DwellIcon fontSize="small" />,
    requiredPermission: 'ANALYTICS_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="ANALYTICS_READ">
          <DwellTimePage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.dwellTime' },
  },
  {
    title: 'sidebar:gateway.eventos',
    path: '/Gateway/Events',
    icon: <EventsIcon fontSize="small" />,
    badge: true,
    requiredPermission: 'ANALYTICS_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="ANALYTICS_READ">
          <EventsMonitorPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.events' },
  },
  // Device status — navigable but not a sidebar entry (accessed from Dispositivos)
  {
    path: '/Gateway/Devices/:deviceId/Status',
    requiredPermission: 'DEVICE_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="DEVICE_READ">
          <DeviceStatusPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.deviceStatus' },
  },
  // Export — navigable but not a sidebar entry (accessed from Contagens)
  {
    path: '/Gateway/Export',
    requiredPermission: 'ANALYTICS_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="ANALYTICS_READ">
          <ExportPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.export' },
  },
  {
    path: '/Gateway/Stores',
    element: <Navigate to="/Gateway/Clients" replace />,
  },
  // ── ADMINISTRAÇÃO section label (sidebar only)
  { sectionLabel: 'sidebar:gateway.administracaoLabel' },
  {
    title: 'sidebar:gateway.utilizadores',
    path: '/Gateway/Users',
    icon: <UsersIcon fontSize="small" />,
    requiredPermission: 'USER_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="USER_READ">
          <UserManagementList />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.users' },
  },
  {
    path: '/Gateway/Users/:userId',
    requiredPermission: 'USER_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="USER_READ">
          <UserDetailPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.userDetail' },
  },
  {
    title: 'sidebar:gateway.clientesLojas',
    path: '/Gateway/Clients',
    icon: <ClientsIcon fontSize="small" />,
    allowedRoles: ['GATEWAY_ADMIN', 'CLIENT_ADMIN'],
    element: (
      <DashboardLayout>
        <AuthGuard allowedRoles={['GATEWAY_ADMIN', 'CLIENT_ADMIN']}>
          <ClientsAndStoresPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.clientsStores' },
  },
  {
    path: '/Gateway/Clients/:clientId',
    allowedRoles: ['GATEWAY_ADMIN', 'CLIENT_ADMIN'],
    element: (
      <DashboardLayout>
        <AuthGuard allowedRoles={['GATEWAY_ADMIN', 'CLIENT_ADMIN']}>
          <ClientDetailPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.clientDetail' },
  },
  // Store detail — navigable from Clientes & Lojas store rows
  {
    path: '/Gateway/Stores/:storeId',
    requiredPermission: 'STORE_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="STORE_READ">
          <StoreDetailPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.stores' },
  },
  {
    title: 'sidebar:gateway.dispositivos',
    path: '/Gateway/Devices',
    icon: <DevicesIcon fontSize="small" />,
    requiredPermission: 'DEVICE_READ',
    element: (
      <DashboardLayout>
        <AuthGuard requiredPermission="DEVICE_READ">
          <DevicesPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.devices' },
  },
  {
    path: '/Gateway/Devices/:deviceId',
    element: (
      <DashboardLayout>
        <AuthGuard allowedRoles={['GATEWAY_ADMIN', 'CLIENT_ADMIN']}>
          <DeviceDetailPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.devices' },
  },
  {
    title: 'sidebar:gateway.ingestion',
    path: '/Gateway/Ingestion',
    icon: <IngestionIcon fontSize="small" />,
    allowedRoles: ['GATEWAY_ADMIN'],
    element: (
      <DashboardLayout>
        <AuthGuard allowedRoles={['GATEWAY_ADMIN']}>
          <IngestionMonitorPage />
        </AuthGuard>
      </DashboardLayout>
    ),
    handle: { crumb: 'sidebar:gateway.ingestion' },
  },
  {
    path: "/404",
    element: <NotFound />,
  },
  {
    path: "/401",
    element: <AuthorizationRequired />,
  },
  {
    path: "/500",
    element: <ServerError />,
  },
  {
    path: "/error/",
    children: [
      {
        path: "404",
        element: <NotFound />,
      },
      {
        path: "401",
        element: <AuthorizationRequired />,
      },
      {
        path: "500",
        element: <ServerError />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

function assembleRoute(route, parentElement, pathPrefix = "") {
  const _path = pathPrefix + route.path;
  /* eslint-disable react/no-children-prop */
  //const Wut = () => { return <ParentElement>{route.element}</ParentElement> };
  const _element = parentElement
    ? React.cloneElement(parentElement, null, route.element)
    : route.element;
  const _handle = route.handle;
  const defaultArr = route.element
    ? [
      {
        path: _path.replace("//", "/"),
        element: _element,
        handle: _handle,
      },
    ]
    : [];

  if (route?.children?.length > 0) {
    const _routes = route.children.map((r) =>
      assembleRoute(r, route.element, route.path));
    defaultArr.push(_routes);
  }
  return defaultArr;
}

const routesCollection = knownRoutes.map((r) => assembleRoute(r));
const router = createBrowserRouter(flatten(routesCollection));

export const Routes = () => {
  const auth = useAuth();

  // Public routes — accessible without authentication
  if (window.location.pathname === '/set-password') {
    return <SetPasswordPage mode="definition" />;
  }
  if (window.location.pathname === '/reset-password') {
    return <SetPasswordPage mode="redefinition" />;
  }

  if (!auth.isInitialized) return <SplashScreen />;
  if (!auth.isAuthenticated) return <LoginPage />;
  return <RouterProvider router={router} />;
};

export const Authentication = async (instance) => {
  const loginAD = () => {
    return new Promise(async (resolve) => {
      await instance.handleRedirectPromise();
      if (instance && instance.getAllAccounts()[0]) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: instance.getAllAccounts()[0],
          })
          .then((response) => {
            resolve(response.accessToken);
          })
          .catch((err) => {
            console.log(err);
            if (err.name === "InteractionRequiredAuthError") {
              instance
                .acquireTokenPopup({
                  ...loginRequest,
                  account: instance.getAllAccounts()[0],
                })
                .then((response) => {
                  resolve(response.accessToken);
                });
            }
          });
      } else {
        instance.loginRedirect(loginRequest);
      }
    });
  };
  const adResponse = await loginAD();
  if (adResponse) {
    const accountLoggedIn = instance.getAllAccounts()[0];
    localStorage.setItem("accessToken", JSON.stringify(adResponse));
    localStorage.setItem("userLoggedIn", JSON.stringify(accountLoggedIn));
  }
  return adResponse;
};
